// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
((Drupal, once) => {
  function toggleFooterMenus() {
    const menus = document.querySelectorAll(".footer__menu details");

    if (window.innerWidth < 992) {
      menus.forEach((menu) => {
        menu.removeAttribute("open");
      });
    } else {
      menus.forEach((menu) => {
        menu.setAttribute("open", "open");
      });
    }
  }

  window.addEventListener("resize", () => {
    toggleFooterMenus();
  });

  toggleFooterMenus();

  function menuToggle(button) {
    const htmlTag = document.getElementsByTagName("html");
    const html = htmlTag[0];

    button.addEventListener("click", () => {
      html.classList.toggle("menu-open");
      const menuId = button.dataset.menuid;
      const menu = document.getElementById(menuId);
      const firstItem = menu.querySelectorAll(
        ":scope > .menu__list:first-child > .menu__item:first-child > a:first-child",
      )[0];
      firstItem.focus();
    });
  }

  function isTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  function addMenuFunction(menu) {
    const menuLists = menu.getElementsByClassName("menu__list");

    // eslint-disable-next-line no-restricted-syntax
    for (const list of menuLists) {
      const menuItems = list.querySelectorAll(":scope > .menu__item");
      // eslint-disable-next-line no-restricted-syntax
      for (const item of menuItems) {
        item.addEventListener("mouseout", () => {
          if (!isTouchDevice) {
            item.classList.remove("menu__item--active");
          }
        });

        const toggles = item.querySelectorAll(":scope > .menu__item-toggle");
        // eslint-disable-next-line no-restricted-syntax
        for (const toggle of toggles) {
          if (toggle.classList.contains("menu__item-toggle--back")) {
            toggle.addEventListener("click", () => {
              toggle
                .closest(".menu__item--active")
                .classList.remove("menu__item--active");
            });
          } else {
            toggle.addEventListener("click", () => {
              if (toggle.parentNode.classList.contains("menu__item--active")) {
                toggle.parentNode.classList.remove("menu__item--active");
              } else {
                toggle.parentNode.classList.add("menu__item--active");
              }
            });
          }
        }
      }
    }
  }

  Drupal.behaviors.menuToggleAction = {
    attach(context) {
      const toggleButtons = once("menu-toggle-button", ".menu-toggle", context);

      toggleButtons.forEach(menuToggle);
    },
  };

  Drupal.behaviors.menuFunctions = {
    attach(context) {
      const root = document.documentElement;
      const header = document.getElementsByClassName("header")[0];

      root.style.setProperty(
        "--mobile-menu-height",
        `calc(100vh - ${header.offsetHeight}px)`,
      );

      const menus = once("menu", ".menu", context);

      menus.forEach(addMenuFunction);
    },
  };

  Drupal.behaviors.menuScroll = {
    attach() {
      window.addEventListener("scroll", () => {
        const header = document.getElementsByClassName("header");
        if (document.documentElement.scrollTop > 0) {
          header[0].classList.add("header--scrolled");
        } else {
          header[0].classList.remove("header--scrolled");
        }
      });
    },
  };
})(Drupal, once);
